import { renderPreview } from './template-variables';

interface Props {
  body: string;
}

export function SmsPreview({ body }: Props): React.ReactNode {
  const rendered = renderPreview(body);

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Phone mockup */}
      <div className="relative mx-auto w-65">
        {/* Phone frame */}
        <div className="rounded-[2.5rem] border-8 border-slate-800 bg-slate-800 shadow-xl">
          {/* Notch */}
          <div className="absolute left-1/2 top-0 h-5 w-24 -translate-x-1/2 rounded-b-xl bg-slate-800" />
          {/* Screen */}
          <div className="min-h-120 overflow-hidden rounded-[2rem] bg-slate-100">
            {/* Status bar */}
            <div className="flex h-8 items-center justify-between bg-slate-100 px-4 pt-1">
              <span className="text-[10px] font-medium text-slate-600">9:41</span>
              <div className="flex items-center gap-1">
                <div className="h-2 w-2 rounded-full bg-slate-400" />
                <div className="h-2 w-3 rounded-sm bg-slate-400" />
                <div className="h-2 w-4 rounded-sm bg-slate-400" />
              </div>
            </div>
            {/* Contact header */}
            <div className="flex items-center gap-2 border-b border-slate-200 bg-white px-3 py-2">
              <div className="flex size-8 items-center justify-center rounded-full bg-blue-100">
                <span className="text-xs font-semibold text-blue-700">K</span>
              </div>
              <span className="text-sm font-medium text-slate-800">Kiku</span>
            </div>
            {/* Message bubble */}
            <div className="p-3 pt-4">
              <div className="max-w-[85%] rounded-2xl rounded-tl-sm bg-green-500 px-3 py-2">
                <p className="break-all whitespace-pre-wrap text-xs leading-relaxed text-white">
                  {rendered}
                </p>
              </div>
              <p className="mt-1.5 text-right text-[10px] text-slate-400">Delivered</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
